import { AssemblyHeaderRow, PartTypeRow } from 'model/Project/BoMItemRow'
import { RootAppState } from 'store/configureStore'

export const VisibleWorkingStepsSelector = (state: RootAppState) => {
  if (state.project.filters?.byArticleId.active) {
    const visibleWorkingSteps = new Set(
      state.project.assemblyHeadersIds
        .map((x) => state.project.flatView[x] as AssemblyHeaderRow)
        .flatMap((x) => x.filteredPartTypeIds)
        .map((x) => state.project.flatView[x] as PartTypeRow)
        .flatMap((x) => x.workingSteps?.map((x) => x.primaryWorkingStep))
    )

    return Array.from(visibleWorkingSteps)
  }

  return Array.from(
    new Set(
      Object.values(state.project?.priceSummaries)
        .filter(
          (x) =>
            x?.isWorkingStep &&
            x.workingStep.primaryWorkingStep ===
              x.workingStep.secondaryWorkingStep
        )
        .map((x) => x.workingStep.primaryWorkingStep)
    )
  )
}
